import './bootstrap';
import { createApp } from 'vue/dist/vue.esm-bundler';
import { createStore } from 'vuex';
import WOW from 'wow.js';
import { jarallax } from 'jarallax/dist/jarallax.esm.min.js';
import * as bootstrap from 'bootstrap';
import Cookies from 'js-cookie';

import Voice from '@components/Voice.vue';
import VoiceMin from '@components/VoiceMin.vue';
import Vocabulary from '@components/vocabulary/Vocabulary.vue';
import Word from '@components/vocabulary/Word.vue';
import HideSolution from '@components/HideSolution.vue';
import ToggleSolution from '@components/ToggleSolution.vue';
import Verbs from '@components/Verbs.vue';
import TtsMain from '@components/tools/tts/TtsMain.vue';
import Translit from '@components/tools/translit/Translit.vue';
import GiftConstructor from '@components/GiftConstructor.vue';
import RangeSlider from '@components/RangeSlider.vue';
import TrainNumbers from '@components/training/numbers/TrainNumbers.vue';

import { lessonsModule } from './vuex/lessonsModule';
import { trainNumbersModule } from './vuex/train/trainNumbersModule';

import CyrillicToTranslit from 'cyrillic-to-translit-js';
import { v4 as uuidv4 } from 'uuid';
import ClipboardJS from 'clipboard';

import * as Sentry from "@sentry/browser";

Sentry.init({
    dsn: "https://738d9e86a6113f3fe9bee28f2fa93167@o4509938946867200.ingest.de.sentry.io/4509938948243536",

    // Adds request headers and IP for users, for more info visit:
    // https://docs.sentry.io/platforms/javascript/configuration/options/#sendDefaultPii
    sendDefaultPii: true,

    // Alternatively, use `process.env.npm_package_version` for a dynamic release version
    // if your build tool supports it.
    release: import.meta.env.npm_package_version,
    integrations: [
        Sentry.browserTracingIntegration(),
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for tracing.
    // We recommend adjusting this value in production
    // Learn more at
    // https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
    tracesSampleRate: 1.0,

    // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
    tracePropagationTargets: ["localhost", /^https:\/\/geolang\.ru/],

    // Block extension errors
    denyUrls: [
        /^chrome-extension:\/\//,
    ],

    ignoreErrors: [
        /^Non-Error promise rejection captured with value/
    ]
});

window.bootstrap = bootstrap;
window.jarallax = jarallax;
window.uuidv4 = uuidv4;
window.ClipboardJS = ClipboardJS;

window.Cookies = Cookies;

new WOW().init();

window.cyrillicToTranslit = new CyrillicToTranslit();

// Additional function to randomize array correctly
Array.prototype.shuffle = function () {
    let currentIndex = this.length, randomIndex;
    // While there remain elements to shuffle...
    while (currentIndex !== 0) {
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;
        [this[currentIndex], this[randomIndex]] = [this[randomIndex], this[currentIndex]];
    }
    return this;
};

$(document).ready(function() {
    $('.modal-hashtag')
        // On modal open => add hashtag
        .on('shown.bs.modal', function(){
            window.location.hash = this.id;
        })
        // On modal close => remove hashtag
        .on('hidden.bs.modal', function(){
            history.pushState("", document.title, window.location.pathname + window.location.search);
        });

    $('.input-password').each(function() {
        $(this).wrap($('<div>', {class: 'position-relative d-flex align-items-center'}));
        if ($(this).hasClass('is-invalid')) {
            $(this).parent().addClass('is-invalid')
        }
        $(this).after($('<i>', {role: 'button', class: 'fa-solid fa-eye'}) );
    })
    $('.input-password + i').on('click', function() {
        $(this).toggleClass('fa-eye').toggleClass('fa-eye-slash');
        $(this).siblings('input').attr('type', function(index, attr){
            return attr === 'password' ? 'text' : 'password';
        });
    })

    // Scroll after click with an offset
    $('a[href*="#"]:not([role])').on('click', function(e) {
        let hash = $(this).attr('href').split('#').pop();
        if (hash && $(`#${hash}`).length) {
            e.preventDefault();
            $([document.documentElement, document.body]).animate({
                scrollTop: $('#' + hash).offset().top - 100
            }, 300);
        }
    })

    // Table hover fix (hover all small cells related to big one with a rowspan attribute)
    $('.table-hover td[rowspan]')
        .on('mouseover', function() {
            let nextTrCount = $(this).attr('rowspan') - 1;
            let nextTrs = Array.from($(this).parent().nextAll()).slice(0, nextTrCount);
            for (let tr of nextTrs) {
                $(tr).addClass('hover');
            }
        })
        .on('mouseleave', function() {
            $(this).closest('.table').find('.hover').removeClass('hover');
        });
    // Table hover fix (hover associated big cell with a rowspan attribute)
    $('.table-hover td[data-assoc]')
        .on('mouseover', function() {
            $(this).closest('.table').find(`td[data-id="${$(this).attr('data-assoc')}"]`).addClass('hover');
        })
        .on('mouseleave', function() {
            $(this).closest('.table').find('.hover').removeClass('hover');
        });

    // Try to open modal by hashtag or scroll to the block
    if (document.location.hash) {
        const hash = document.location.hash.substring(1);
        const $el = $('.modal-hashtag#' + hash)[0];
        if ($el) {
            new bootstrap.Modal($el).show();
        } else if ($('#' + hash).length) {
            $([document.documentElement, document.body]).animate({
                scrollTop: $('#' + hash).offset().top - 100
            }, 300);
        }
    }

    // Initialize bootstrap tooltips
    $('[data-bs-toggle="tooltip"]').map((i, el) => new bootstrap.Tooltip(el))

    // Auto-selection of a review type
    $('body').on('click', '[data-bs-target="#review-modal"]', function() {
        let reviewType = $(this).attr('data-review-type')
        if (reviewType) {
            $(`#review-modal button[data-target="${reviewType}"]`).click()
        }
    })

    // Links that are not available in the menu / temporarily disabled
    $('a.not-available')
        .on('mousedown click', function(e) {
            e.preventDefault();
            e.stopPropagation();
        })
        .each(function() {
            $(this).attr('data-bs-toggle', 'tooltip').attr('data-bs-placement', 'right').attr('title', 'Временно недоступно');
            new bootstrap.Tooltip(this)
        })

    // Feedback
    $('#feedback-wrapper').on('click', function(){
        const feedbackModal = new bootstrap.Modal(document.getElementById('feedback-modal'))
        feedbackModal.show()
    })
    $('#feedback-wrapper button').on('click', function(e){
        e.stopPropagation()
        $('.feedback-wrapper').hide()
        $('body').removeClass('request-feedback')
        Cookies.set('hide-feedback-form', 1, { expires: 10000 })
    })
    $('#feedback-modal .form-check-input').on('change', function() {
        const disableCheckboxes = $('#feedback-modal .form-check-input:checked').length >= 5
        $('#feedback-modal .form-check-input:not(:checked)').prop('disabled', disableCheckboxes)
    })
    $('#feedback-other-checkbox').on('change', function() {
        $('#feedback-other').toggleClass('d-none', !this.checked)
    })
    $('#feedback-modal form').on('submit', function(e) {
        e.preventDefault();
        const isCheckboxesChecked = !!$('#feedback-modal .form-check-input:checked').length
        $('#feedback-needed-error').toggleClass('d-none', isCheckboxesChecked)
        if (isCheckboxesChecked) {
            $('button[type="submit"]').addClass('disabled')
            const formData = new FormData(this)
            if (!$('#feedback-other-checkbox').is(':checked') || !formData.get('needed_other').length) {
                formData.delete('needed_other')
            }

            $.ajax({
                url: $(this).attr('action'),
                data: formData,
                type: $(this).attr('method'),
                contentType: false,
                processData: false,
                beforeSend: () => {
                    $('button[type="submit"] .submit-text', this).addClass('d-none')
                    $('button[type="submit"] .spinner-border', this).removeClass('d-none')
                },
                success: function (data, status) {
                    $('#feedback-modal .modal-body').html('<h2 class="fw-bold">Данные отправлены. Спасибо!</h2>')
                    $('#feedback-modal').on('hide.bs.modal', function () {
                        $('#feedback-wrapper').remove()
                        $('body').removeClass('request-feedback')
                        Cookies.set('hide-feedback-form', 1, { expires: 10000 })
                    })
                },
                error: (xhr, desc, err) => {
                    $('#feedback-modal .modal-body').html('<h4 class="fw-bold text-danger mt-0 mb-3">Неизвестная ошибка</h4><p class="fw-bold lead mb-2">Пожалуйста, напишите нам напрямую: <a class="link" href="mailto:info@geolang.ru">info@geolang.ru</a></p>')
                },
            })
        }
    })
})

const store = createStore({
    modules: {
        lessonsModule,
        trainNumbersModule
    }
})

const app = createApp()
app.component('Voice', Voice)
app.component('VoiceMin', VoiceMin)
app.component('Vocabulary', Vocabulary)
app.component('Word', Word)
app.component('HideSolution', HideSolution)
app.component('ToggleSolution', ToggleSolution)
app.component('Verbs', Verbs)
app.component('TtsMain', TtsMain)
app.component('RangeSlider', RangeSlider)
app.component('TrainNumbers', TrainNumbers)
app.component('Translit', Translit)
app.component('GiftConstructor', GiftConstructor)

app.use(store)

app.mount('#app')
